import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ListCardComponent} from './list-card.component';
import {PipesModule} from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    ListCardComponent
  ],
  exports: [
    ListCardComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    PipesModule
  ]
})
export class ListCardModule { }
